import { toast as toastify } from 'react-toastify'
import { debug } from 'lib/logging'

/**
 * Displays a success toast notification
 * @param {string} message - The message to display
 * @returns {void}
 * @description Shows a success toast that auto-closes after 2 seconds
 */
export function toast(message: string) {
  toastify(message, {
    autoClose: 2000,
    type: `success`,
  })
}

/**
 * Displays a success toast notification
 * @param {string} message - The success message to display
 * @returns {void}
 * @description Shows a success toast that auto-closes after 3 seconds
 */
export function successToast(message: string) {
  debug(`toast`, `success toast`, message)
  toastify(message, {
    autoClose: 3000,
    type: `success`,
  })
}

/**
 * Displays an error toast notification
 * @param {string} message - The error message to display
 * @returns {void}
 * @description Shows an error toast that auto-closes after 5 seconds and pauses on hover
 */
export function errorToast(message: string) {
  debug(`toast`, `error toast`, message)
  toastify(message, {
    pauseOnHover: true,
    autoClose: 5000,
    type: `error`,
  })
}
